import {
  ADD_ORDER,
  SET_CHECKOUT_ORDER_INFO,
  SET_CURRENT_ORDER,
  SET_ORDERS,
  UPDATE_ORDER,
} from "../actions/types";

const initialState = {
  items: [],
  checkoutOrder: {},
  currentOrder: {},
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ORDERS: {
      return {
        ...state,
        items: action.data,
      };
    }
    case ADD_ORDER: {
      return {
        ...state,
        items: [action.data, ...state.items],
      };
    }
    case SET_CHECKOUT_ORDER_INFO: {
      return {
        ...state,
        checkoutOrder: action.data,
      };
    }
    case SET_CURRENT_ORDER: {
      return {
        ...state,
        currentOrder: action.data,
      };
    }
    case UPDATE_ORDER: {
      let currentOrder = {};
      let updatedItems = state.items.map((item) => {
        if (item._id === action.data._id) {
          item = { ...item, ...action.data };
          if (state.currentOrder._id === action.data._id) {
            currentOrder = { ...state.currentOrder, ...action.data };
          }
        }
        return item;
      });
      return {
        ...state,
        items: [...updatedItems],
        currentOrder: { ...state.currentOrder, ...currentOrder },
      };
    }
    default:
      return state;
  }
};

export default orderReducer;
